import './ConfigDialog.scss';

// import { Field, useFormikContext } from 'formik';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { Dialog } from 'primereact/dialog';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// import { ConstantFields } from './CreateEditDialog.functions';

type Props = {
  visible: boolean;
  onHide: () => void;
  onStart: () => void;
};

export function GroupOrderConfig({ visible, onHide, onStart }: Props) {
  const { t } = useTranslation();

  // const { watch } = useFormContext();
  // const values = watch();

  const configDialogFooter = (
    <div>
      <Button
        label="Start"
        onClick={onStart}
        type="button"
        data-cy="start-btn"
      />
    </div>
  );

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      header={t('Group Order Config')}
      footer={configDialogFooter}
      maximizable
      className="group-order-config-dialog"
    >
      <div className="p-pb-5">{t('Select constant field groups')}:</div>

      <div className="p-field">
        <div className="p-field-radiobutton">
          <Controller
            name="isSenderConstant"
            render={({ field }) => (
              <>
                <Checkbox
                  id="isSenderConstant"
                  name="isSenderConstant"
                  value={field.value}
                  checked={field.value}
                  onChange={field.onChange}
                />
                <label htmlFor="isSenderConstant" data-cy="isSenderConstant">
                  {t('Sender')}
                </label>
              </>
            )}
          />
          {/* <Field
            as={Checkbox}
            inputId="sender"
            name="isSenderConstant"
            checked={values?.isSenderConstant}
          />
          <label htmlFor="sender" data-cy="sender-cbx">
            {t('Sender')}
          </label> */}
        </div>

        <div className="p-field-radiobutton">
          <Controller
            name="isRecipientConstant"
            render={({ field }) => (
              <>
                <Checkbox
                  id="isRecipientConstant"
                  name="isRecipientConstant"
                  value={field.value}
                  checked={field.value}
                  onChange={field.onChange}
                />
                <label
                  htmlFor="isRecipientConstant"
                  data-cy="isRecipientConstant"
                >
                  {t('Recipient')}
                </label>
              </>
            )}
          />
          {/* <Field
            as={Checkbox}
            inputId="recipient"
            name="isRecipientConstant"
            checked={values?.isRecipientConstant}
          />
          <label htmlFor="recipient">{t('Recipient')}</label> */}
        </div>

        <div className="p-field-checkbox">
          <Controller
            name="isOrdererConstant"
            render={({ field }) => (
              <>
                <Checkbox
                  id="isOrdererConstant"
                  name="isOrdererConstant"
                  value={field.value}
                  checked={field.value}
                  onChange={field.onChange}
                />
                <label htmlFor="isOrdererConstant" data-cy="isOrdererConstant">
                  {t('Orderer')}
                </label>
              </>
            )}
          />
          {/* <Field
            as={Checkbox}
            inputId="Orderer"
            name="isOrdererConstant"
            checked={values?.isOrdererConstant}
          />
          <label htmlFor="Orderer">{t('Orderer')}</label> */}
        </div>

        <div className="p-field-checkbox">
          <Controller
            name="isAttributesConstant"
            render={({ field }) => (
              <>
                <Checkbox
                  id="isAttributesConstant"
                  name="isAttributesConstant"
                  value={field.value}
                  checked={field.value}
                  onChange={field.onChange}
                />
                <label
                  htmlFor="isAttributesConstant"
                  data-cy="isAttributesConstant"
                >
                  {t('Attributes')}
                </label>
              </>
            )}
          />
          {/* <Field
            as={Checkbox}
            checked={values?.isAttributesConstant}
            inputId="Attributes"
            name="isAttributesConstant"
          />
          <label htmlFor="Attributes" data-cy="attributes-cbx">
            {t('Attributes')}
          </label> */}
        </div>
      </div>
    </Dialog>
  );
}
